import React from 'react';
import logo from '../../assets/icons/logo.svg';
import NavItem from '../common/navitem';
import './header.css';
import { useTranslation } from 'react-i18next';

const Header = () => {
    const {t, i18n } = useTranslation();

    function handleLanguageClick() {
        const newLang = i18n.language === "en" ? "ar" : "en";
        i18n.changeLanguage(newLang);
      }
    return ( 
        <>
        <div className="headerPadding">
            <header>
                <img src={logo} alt="book icon" />
                <ul>
                    <nav>
                        <ul className='displayNone'>
                            <NavItem id="#home" navitem={t("Home")} />
                            <NavItem id="#listing" navitem={t("Listing")} />
                            <NavItem id="#upcoming" navitem={t("Upcoming")} />
                            <NavItem id="#featured" navitem={t("Featured")} />
                            <NavItem id="#about" navitem={t("About")} />
                            <NavItem id="#book" navitem={t("Book")} />
                            <NavItem id="#reviews" navitem={t("Reviews")} />
                            <NavItem id="#subscribe" navitem={t("Subscribe")} />
                        </ul>
                    </nav>
                </ul>
                <button onClick={handleLanguageClick}>
                    <div className="lang"></div>
                </button>
            </header>
        </div>
        </>
     );
}
 
export default Header;